export default __webpack_public_path__ + "static/media/422-Series-Stainless-Regulators.dc32321f.jpg";